import { useState } from "react";

import { useRootStore } from "store";
import { uploadFileErrorMessage } from "common/consts/uploadFileErrors";

export default function useSetErrorOnUpload() {
  const [failed, setFailed] = useState<boolean>(false);
  const [failMessage, setFailMessage] = useState<string>("");

  const setFailedWrapper = (isFailed: boolean, message: string) => {
    if (message && message in uploadFileErrorMessage) {
      setFailMessage(message);
      setFailed(isFailed);
      return isFailed;
    } else {
      useRootStore
        .getState()
        .error.appendErrorNotification(
          "Filöverföringen misslyckades.",
          message
        );
      return false;
    }
  };

  return {
    failed,
    setFailed,
    failMessage,
    setFailMessage,
    setFailedWrapper
  };
}
